import { CORE_DEFAULT_VALUES } from '../../core/config/defaultValues/defaultValues';
import { APP_DEFAULT_VALUES } from '../../app/config/defaultValues/defaultValues';

export const DEFAULT_VALUES = {
  ...CORE_DEFAULT_VALUES,
  ...APP_DEFAULT_VALUES,
  defaultCountryState: 'GB',
  currencyState: '£',
  isInternationalCountryName: true,
  isDateSelectPreferred: false,
  defaultCardStyle: {
    border: `1px solid rgba(145, 158, 171, 0.5)`,
    borderRadius: '16px',
  },
  defaultCountry: 'GB',
};
